// La solicitud OAuth pendiente (DOT ↔ SOFÍA · PHASE 01): si Supabase manda a /oauth/consent sin sesión, el
// `authorization_id` se guarda acá y LoginRoute devuelve al Owner a la pantalla de autorización al entrar.
export const CLAVE_AUTORIZACION_PENDIENTE = 'feriaos.oauth.authorization_id';

export function guardarAutorizacionPendiente(id) {
  try { window.sessionStorage.setItem(CLAVE_AUTORIZACION_PENDIENTE, String(id || '')); } catch (_e) { /* modo privado */ }
}

export function verAutorizacionPendiente() {
  try { return window.sessionStorage.getItem(CLAVE_AUTORIZACION_PENDIENTE) || ''; } catch (_e) { return ''; }
}

export function tomarAutorizacionPendiente() {
  const id = verAutorizacionPendiente();
  try { if (id) window.sessionStorage.removeItem(CLAVE_AUTORIZACION_PENDIENTE); } catch (_e) { /* modo privado */ }
  return id;
}
